var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { BaseService } from './base.service';
var ContentBaseService = /** @class */ (function (_super) {
    __extends(ContentBaseService, _super);
    function ContentBaseService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.baseUrl = 'please_override';
        return _this;
    }
    ContentBaseService.prototype.getBaseUrl = function () {
        return this.baseUrl;
    };
    ContentBaseService.prototype.setBaseUrl = function (url) {
        this.baseUrl = url;
    };
    ContentBaseService.prototype.getRecord = function (id) {
        if (id == null) {
            return this.api.get("" + this.getBaseUrl());
        }
        else {
            return this.api.get(this.getBaseUrl() + "/" + id);
        }
    };
    ContentBaseService.prototype.updateRecord = function (rec, id) {
        if (id == null) {
            return this.api.put("" + this.getBaseUrl(), rec);
        }
        else {
            return this.api.put(this.getBaseUrl() + "/" + id, rec);
        }
    };
    ContentBaseService.prototype.deleteRecord = function (id) {
        if (id == null) {
            return this.api.delete("" + this.getBaseUrl());
        }
        else {
            return this.api.delete(this.getBaseUrl() + "/" + id);
        }
    };
    ContentBaseService.prototype.postRecord = function (rec, id) {
        if (id == null) {
            return this.api.post("" + this.getBaseUrl(), rec);
        }
        else {
            return this.api.post(this.getBaseUrl() + "/" + id, rec);
        }
    };
    ContentBaseService.prototype.getType = function (name, query) {
        var url = '/v1/type?name=' + name;
        if (typeof query !== 'undefined') {
            url = url + '&query=' + JSON.stringify(query);
        }
        this.setBaseUrl(url);
        return this.getRecord();
    };
    ContentBaseService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ContentBaseService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return ContentBaseService;
}(BaseService));
export { ContentBaseService };
//# sourceMappingURL=contentbase.service.js.map